import { render, staticRenderFns } from "./management-report.page.vue?vue&type=template&id=4d393bf5"
import script from "./management-report.page.vue?vue&type=script&lang=js"
export * from "./management-report.page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports